export const RouteType = {
    SERVICE: "/service",
    LOGIN: "/login",
    CHECKOUT: "/payment",
    PAYMENTINIT: "/paymentInit",
    PAY: "/pay",
    PAYMENT_ACTIVE: "/paymentActive",
    STATUS: "/status",
    paymentActiveNew: "/api/v2/payin/detailsPay",
    txnPayState: "/api/v2/payin/txnPayState",
};
